export default __webpack_public_path__ + "cakewalk-sonar.9f91b077.png";